<template>
  <div class="space-y-1">
    <div
      class="flex items-center px-3 py-2 text-xs font-bold uppercase tracking-wider text-white/90 select-none"
    >
      <span>Strony</span>
    </div>

    <div class="ml-4 space-y-1">
      <div
        v-for="page in pages"
        :key="page.id"
        class="group/page-row flex items-center"
      >
        <Link
          :href="pageRoutes.configuration(page.slug)"
          :class="[
            'group nav-link flex-1 min-w-0',
            isConfigurationActive(page.slug) ? 'nav-link-active' : 'nav-link-inactive',
          ]"
        >
          <span class="truncate capitalize">{{ page.slug }}</span>
        </Link>

        <button
          v-if="!page.protected"
          type="button"
          class="ml-1 shrink-0 rounded p-1 text-white/40 opacity-0 transition-all hover:bg-white/10 hover:text-white group-hover/page-row:opacity-100"
          title="Usuń stronę"
          @click.prevent="destroyPage(page)"
        >
          <icon name="trash" class="h-3.5 w-3.5 stroke-current" />
        </button>
      </div>

      <button
        type="button"
        class="group nav-link nav-link-inactive flex w-full items-center text-left"
        @click="modalOpen = true"
      >
        <span class="text-white/70">+ Dodaj stronę</span>
      </button>
    </div>

    <Modal
      :open="modalOpen"
      title="Dodaj stronę"
      @close="modalOpen = false"
    >
      <NewPage :site_context="siteContext" @success="onCreated" />
    </Modal>
  </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import Modal from '@/Shared/Modal.vue';
import NewPage from '@/Pages/Admin/Pages/_New.vue';
import {
  createPageRouteHelper,
  pagesPropKeyFor,
} from '@/utils/createPageRouteHelper';

export default {
  components: {
    Link,
    Icon,
    Modal,
    NewPage,
  },
  props: {
    // Site context this section belongs to. Defaults to 'code_medical_center'
    // (the root CODE site at `/`); other values mirror Page::SITE_CONTEXTS.
    // eslint-disable-next-line vue/prop-name-casing
    site_context: {
      type: String,
      default: 'code_medical_center',
    },
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  computed: {
    siteContext() {
      return this.site_context;
    },
    pageRoutes() {
      return createPageRouteHelper(this.siteContext, this.$routes);
    },
    pages() {
      const all = this.$page.props.pages_by_site_context || {};
      return all[pagesPropKeyFor(this.siteContext)] || [];
    },
  },
  methods: {
    isConfigurationActive(slug) {
      const currentUrl = this.$page.url.slice(1).replace(/\/$/, '');
      const target = `${this.pageRoutes.pathPrefix}/${slug}/configuration`;
      return currentUrl === target;
    },
    destroyPage(page) {
      if (page.protected) return;
      if (!confirm(`Usunąć stronę '${page.slug}'? Operacja jest nieodwracalna.`)) return;

      router.delete(this.pageRoutes.destroy(page.id), {
        preserveScroll: true,
      });
    },
    onCreated() {
      this.modalOpen = false;
    },
  },
};
</script>
